import React from 'react';

/**
 * Componente para botones de navegación del wizard
 * Maneja los botones Anterior, Siguiente, Cancelar y Guardar/Crear
 */
const NavigationButtons = ({
  currentStep,
  totalSteps = 4,
  isLoading,
  isEditMode,
  onPrevious,
  onNext,
  onCancel,
  onSubmit,
  onCancelClick,
  onSubmitClick,
  showCancelButton = true,
  hasPendingChanges = false
}) => {
  const handleCancelButtonClick = () => {
    if (onCancelClick) {
      onCancelClick();
    } else {
      onCancel();
    }
  };

  const handleSubmitButtonClick = () => {
    if (onSubmitClick) {
      onSubmitClick();
    } else {
      onSubmit();
    }
  };

  return (
    <div className="d-flex justify-content-between mt-4">
      {/* Botones izquierdos: Anterior y Cancelar */}
      <div className="d-flex align-items-center">
        {currentStep > 1 && (
          <button
            type="button"
            className="btn btn-secondary mr-3"
            onClick={onPrevious}
            disabled={isLoading}
          >
            <i className="fas fa-arrow-left me-1"></i>
            Anterior
          </button>
        )}
        {showCancelButton && (
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={handleCancelButtonClick}
            disabled={isLoading}
          >
            <i className="fas fa-times me-1"></i>
            Cancelar
          </button>
        )}
      </div>
      
      {/* Botones derechos: Siguiente o Guardar */}
      <div>
        {currentStep < totalSteps ? (
          <button
            type="button"
            className="btn btn-primary"
            onClick={onNext}
            disabled={isLoading || hasPendingChanges}
            title={hasPendingChanges ? 'Debe guardar las preguntas antes de continuar' : ''}
          >
            Siguiente
            <i className="fas fa-arrow-right ms-1"></i>
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-success"
            onClick={handleSubmitButtonClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden"></span>
                </div>
                Guardando...
              </>
            ) : (
              <>
                <i className={`fas ${isEditMode ? 'fa-save' : 'fa-plus'} me-1`}></i>
                {isEditMode ? 'Actualizar Evaluación' : 'Crear Evaluación'}
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default NavigationButtons;